/**
 * @fileoverview Custom JavaScript functionality for the Shopify theme
 * @description Implements various UI interactions including cart accordion, search, account handling,
 * dropdown menus, scroll handling, and product filtering
 *
 * Dependencies:
 * - jQuery
 *
 * HTML Structure Required:
 * - Elements with class "sub-heading.shipping" for shipping plan toggles
 * - Elements with class "header__search" for search functionality
 * - Elements with class "header-acount" for account handling
 * - Elements with class "accordion-toggle" for accordion functionality
 * - Elements with class "facets__vendor-list__wrapper" for vendor filtering
 * - Elements with class "custom-header" for header handling
 * - Elements with class "custom-collection-slider" for collection slider
 * - Elements with class "facets__main" for facets handling
 */

let scrollFlag = false;
let isProductPage = document.querySelector('.faqs-container--product');

/**
 * @function refreshCartAccordion
 * @description Initializes click handlers for shipping plan accordion toggles
 */
function refreshCartAccordion() {
  document.querySelectorAll('.sub-heading.shipping').forEach((ele) => {
    ele.addEventListener('click', function (e) {
      this.closest('.shipping-plan').classList.toggle('active');
    });
  });
}

/**
 * @function openSearch
 * @description Sets up click handler for search modal toggle
 */
function openSearch() {
  const search = document.querySelector('.header__search');
  const searchModal = search.querySelector('.search-modal');

  search
    .querySelector('.modal__toggle')
    .addEventListener('click', function (e) {
      if (searchModal) {
      }
    });
}

document.addEventListener('DOMContentLoaded', () => {
  refreshCartAccordion();

  productJsFilters();

  setTimeout(() => {
    discountApply();
  }, 500);

  const hAccount = document.querySelector('.header-acount');
  const hasLoggedIn = window.localStorage.getItem('accountLoggedIn');

  if (!hAccount && hasLoggedIn == 'true') {
    window.localStorage.removeItem('accountLoggedIn');
  }

  if (hAccount && !hasLoggedIn) {
    hAccount.classList.remove('hide');
    setTimeout(() => {
      hAccount.classList.add('hide');
      window.localStorage.setItem('accountLoggedIn', true);
    }, 5000);
  }

  dropDown();

  setTimeout(() => {
    window.addEventListener('scroll', handleScroll);
  }, 400);

  document.querySelector('ul.menu-drawer__menu.list-menu li details')
    ? document
        .querySelector('ul.menu-drawer__menu.list-menu li details')
        .setAttribute('open', '')
    : null;
});

document.querySelectorAll('.accordion-toggle').forEach((element) => {
  element.addEventListener('click', function (e) {
    e.preventDefault();
    let body = document.querySelector('body');
    let timeout = null;
    
    
    if (element.closest('.adt-accordion-item').classList.contains('active')) {

      element.closest('.adt-accordion-item').classList.remove('active');
      
      return;
    }

    document.querySelectorAll('.adt-accordion-item').forEach((adtEle) => {
      adtEle.classList.remove('active');
    });

    element.closest('.adt-accordion-item').classList.toggle('active');
    

    const accordion_url = this.getAttribute('data-url-link');
    if (accordion_url && !isProductPage) {
      history.pushState(null, '', accordion_url);
    }

    if (element.classList.contains('blog')) {
      // Force the header to be hidden during the accordion toggle
      body.classList.add('temp-hide-header');

      const accoY = element.offsetTop;
      window.scrollTo(0, accoY - 70);
      setTimeout(() => {
        document
          .querySelector('.shopify-section-header')
          .classList.add('shopify-section-header-hidden');
      }, 150);

      timeout = setTimeout(() => {
        body.classList.remove('temp-hide-header');
        clearTimeout(timeout);
      }, 1000);

    }


    if (element.classList.contains('product')) {
      // Force the header to be hidden during the accordion toggle
      body.classList.add('temp-hide-header');
    
      const accoY = element.offsetTop;
      window.scrollTo(0, accoY - 70);
      setTimeout(() => {
        document
          .querySelector('.shopify-section-header')
          .classList.add('shopify-section-header-hidden');
      }, 150);

      console.log('cdebug body', body);

      timeout = setTimeout(() => {
        console.log('cdebug body', body);
        body.classList.remove('temp-hide-header');
        clearTimeout(timeout);
      }, 1000);

    }

  });
});

/**
 * @function discountApply
 * @description Toggles 'discounted' class on body based on presence of discount element
 */
function discountApply() {
  const discount_ele = document.querySelector('.apply_discount');
  if (discount_ele) {
    document.body.classList.add('discounted');
  } else {
    document.body.classList.remove('discounted');
  }
}

/**
 * @function dropDown
 * @description Handles vendor list dropdown functionality
 */
function dropDown() {
  let wrapper = document.querySelector('.facets__vendor-list__wrapper');

  if (wrapper) {
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains(wrapper.className)) {
        wrapper.classList.add('show');
        return;
      }

      wrapper.classList.remove('show');
    });
  }
}

/**
 * @function handleScroll
 * @description Manages scroll behavior for header, slider, and facets positioning
 */
function handleScroll() {
  if (scrollFlag == true) {
    $('.vendor-item').removeClass('current');
    scrollFlag = false;
  }

  let header = $('.custom-header');
  let slider = $('.custom-collection-slider');
  let facets = $('.facets__main');

  if (header.hasClass('shopify-section-header-hidden')) {
    slider.css({ top: `-1px` });
    facets.css({ top: `-1px` });
  } else if (!header.hasClass('shopify-section-header-hidden')) {
    slider.css({ top: `${header.height() - 1}px` });
    facets.css({ top: `${header.height() - 1}px` });
  }
}

/**
 * @function productJsFilters
 * @description Implements product filtering functionality including vendor grouping and navigation
 */
function productJsFilters() {
  const $customCollectionSlider = $('.custom-collection-slider');
  const $facetsMain = $('.facets__main');

  let timeout;

  $('.vendor-item').on('click', function (e) {
    e.preventDefault();
    scrollFlag = false;
    clearTimeout(timeout);

    let vendorGroup = $(this).attr('data-vendor-handle').trim();
    let $target = $(`[data-group-handle="${vendorGroup}"]`);
    let targetTop = $target.offset().top - 160;

    if ($target.length) {
      $('html').stop(true, false).animate(
        {
          scrollTop: targetTop,
        },
        1000
      );
    }

    timeout = setTimeout(() => {
      scrollFlag = true;
    }, 1200);

    $('.vendor-item').removeClass('current');
    $(this).addClass('current');
  });

  const productContainer = document.querySelector('#ProductGridContainer');
  const anchorSlider = document.querySelector(
    '.anchor .collection-slider_inner'
  );

  if (anchorSlider) {
    anchorSlider.querySelectorAll('.vendor-item').forEach((item, index) => {
      let eleProductGroup = document.createElement('div');
      eleProductGroup.classList.add('product-group');
      eleProductGroup.setAttribute(
        'data-group-handle',
        item.dataset.vendorHandle
      );
      eleProductGroup.innerHTML += `<div class="product-group__title">${item.innerHTML}</div>
          <ul id="product-grid" data-product-vendor-group="${item.dataset.vendorHandle}" class="collection-product-list collection-product-list--2-mobile load-more-grid">
          
          </ul>
        `;
      if (item.dataset.vendorHandle == 'others') {
        eleProductGroup.style.display = 'none';
      }
      productContainer
        .querySelector('.collection-product')
        .append(eleProductGroup);
    });
  }

  let otherProductLeng = 0;

  if (productContainer) {
    productContainer
      .querySelectorAll('#product-grid .collection-product-card')
      .forEach((card) => {
        const productGroup = productContainer.querySelector(
          `[data-product-vendor-group="${card.dataset.productVendor}"]`
        );
        const otherProductGroup = productContainer.querySelector(
          `[data-product-vendor-group="others"]`
        );

        if (productGroup) {
          productGroup.append(card);
        } else if (otherProductGroup) {
          otherProductGroup.append(card);
          otherProductGroup.closest('.product-group').style.display = 'block';
          otherProductLeng++;
        }
      });

    if (otherProductLeng > 0) {
      anchorSlider.querySelector(
        '[data-vendor-handle="others"]'
      ).style.display = 'block';
    }

    const productVendorGroup = document.querySelector(
      `.product-vendor-group__list`
    );
    const productGroup = productContainer.querySelectorAll(`.product-group`);
    if (anchorSlider) {
      anchorSlider.querySelectorAll('.vendor-item').forEach((item, index) => {
        let productCount = document
          .querySelector(`[data-group-handle="${item.dataset.vendorHandle}"]`)
          .querySelectorAll('.collection-product-card');

        const vendorListItem = document.createElement('div');
        vendorListItem.classList.add('vendor-list__item');
        vendorListItem.setAttribute(
          'data-vendor-handle',
          item.dataset.vendorHandle
        );
        vendorListItem.innerHTML = ` ${item.innerHTML} ${
          productCount
            ? ` <span class="count"> (${productCount.length})</span>`
            : ''
        }`;
        // item.innerHTML = ` ${item.innerHTML} ${ productCount ? `(${productCount.length})` : '' }`;

        if (index < 1) {
          productVendorGroup
            .closest('.facets__vendor-list__wrapper')
            .querySelector('.current__vendor').innerHTML =
            vendorListItem.outerHTML;
        }

        if (productVendorGroup) {
          productVendorGroup.append(vendorListItem);
        }

        productGroup.forEach((group) => {
          if (group.dataset.groupHandle == item.dataset.vendorHandle) {
            group.style.order = index;
          }
        });
      });
    }

    if (productVendorGroup) {
      productVendorGroup
        .querySelectorAll('.vendor-list__item')
        .forEach((group, index) => {
          let parent = productVendorGroup.closest(
            '.facets__vendor-list__wrapper'
          );

          group.addEventListener('click', function (e) {
            parent.querySelector('.current__vendor').innerHTML = this.outerHTML;
            let $target = $(
              `[data-group-handle="${this.dataset.vendorHandle}"]`
            );
            let targetTop = $target.offset().top - 160;

            if ($target.length) {
              $('html').stop(true, false).animate(
                {
                  scrollTop: targetTop,
                },
                800
              );
            }
          });
        });
    }
  }
}
